// src/services/labels.ts
import { supabase } from "../lib/supabase";
import type { ID, Label } from "../types/domain";

/** Lista todas las etiquetas de una compañía. */
export async function listCompanyLabels(companyId: ID) {
  const { data, error } = await supabase
    .from("labels")
    .select("*")
    .eq("company_id", companyId)
    .order("name", { ascending: true });

  return { data: (data as Label[]) ?? [], error };
}

/** Devuelve un mapa task_id -> Label[] para el conjunto de tareas dado. */
export async function getLabelsForTasks(taskIds: ID[]) {
  if (!taskIds.length) return new Map<ID, Label[]>();

  const { data, error } = await supabase
    .from("task_labels")
    .select(`
      task_id,
      label_id,
      labels:labels(
        id, company_id, name, color
      )
    `)
    .in("task_id", taskIds);

  if (error) return new Map<ID, Label[]>();

  const map = new Map<ID, Label[]>();
  (data ?? []).forEach((row: any) => {
    if (!row?.task_id || !row?.labels) return;
    const arr = map.get(row.task_id) ?? [];
    arr.push(row.labels as Label);
    map.set(row.task_id, arr);
  });
  // ordenamos por nombre para visual consistente
  for (const [k, arr] of map.entries()) {
    arr.sort((a, b) => a.name.localeCompare(b.name));
    map.set(k, arr);
  }
  return map;
}

/** Reemplaza todas las etiquetas de una tarea. */
export async function replaceTaskLabels(taskId: ID, labelIds: ID[]) {
  // Borramos todas y reinsertamos (sencillo y suficiente aquí)
  const del = await supabase.from("task_labels").delete().eq("task_id", taskId);
  if (del.error) return { error: del.error };

  if (!labelIds.length) return { error: null };

  const rows = labelIds.map((label_id) => ({ task_id: taskId, label_id }));
  const { error } = await supabase.from("task_labels").insert(rows);
  return { error };
}
